import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  variant?: 'outline' | 'ghost';
  children: ReactNode;
}

export function IconButton({
  label,
  variant = 'ghost',
  className = '',
  children,
  type = 'button',
  ...rest
}: IconButtonProps) {
  const cls = ['tr-iconbtn', `tr-iconbtn--${variant}`, className].filter(Boolean).join(' ');
  return (
    <button type={type} className={cls} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}
